'use client';

import * as React from 'react';
import Alert from '@mui/material/Alert';
import { useNavigate } from 'react-router-dom';

import { paths } from '@/paths';
import { logger } from '@/lib/default-logger';
import { useUser } from '@/hooks/v2/use-user';

export interface ChangePasswordGuardProps {
  children: React.ReactNode;
}

export function ChangePasswordGuard({ children }: ChangePasswordGuardProps): React.JSX.Element | null {
  const navigate = useNavigate();
  const { user, error, isLoading } = useUser();
  const [isChecking, setIsChecking] = React.useState<boolean>(true);

  const checkPermissions = async (): Promise<void> => {
    if (isLoading) {
      return;
    }

    if (error) {
      setIsChecking(false);
      return;
    }

    if (user?.password_change_required) {
      logger.debug('[ChangePasswordGuard]: User is not logged in, redirecting to change password');
      navigate(paths.auth.changePassword, { replace: true });
      return;
    }

    

    setIsChecking(false);
  };

  React.useEffect(() => {
    checkPermissions().catch(() => {
      // noop
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Expected
  }, [user, error, isLoading]);

  if (isChecking) {
    return null;
  }

  if (error) {
    return <Alert color="error">{error}</Alert>;
  }

  return <React.Fragment>{children}</React.Fragment>;
}
